import React, { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";
import { API } from "../utils/constants";

// Auth Context
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("biz360_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(response.data);
        } catch (e) {
          localStorage.removeItem("biz360_token");
          setToken(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("biz360_token", response.data.token);
    setToken(response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const register = async (email, password, prenom, nom) => {
    const response = await axios.post(`${API}/auth/register`, { email, password, prenom, nom });
    localStorage.setItem("biz360_token", response.data.token);
    setToken(response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("biz360_token");
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  };

  const refreshUser = async () => {
    // Rafraîchit `user` depuis /auth/me. À appeler après toute mutation profil
    // (PUT /profile, connexion Urssaf, changement de périodicité) pour éviter
    // les états stales côté client.
    if (!token) return null;
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data);
      return response.data;
    } catch (e) {
      return null;
    }
  };

  const setAuthToken = (newToken, userData) => {
    localStorage.setItem("biz360_token", newToken);
    setToken(newToken);
    if (userData) setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, loading, updateUser, refreshUser, setAuthToken }}>
      {children}
    </AuthContext.Provider>
  );
};
